(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1663,6136,152],{

/***/ 57407:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/we-chat",
      function () {
        return __webpack_require__(98536);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1954);
// ** Icon Imports


const IconifyIcon = (param)=>{
    let { icon , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
        icon: icon,
        fontSize: "1.5rem",
        ...rest
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconifyIcon);


/***/ }),

/***/ 92024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Avatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69661);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41796);
/* harmony import */ var src_core_hooks_useBgColor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19550);
// ** React Imports


// ** MUI Imports


// ** Hooks Imports

const Avatar = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
    // ** Props
    const { sx , src , skin , color  } = props;
    // ** Hook
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const bgColors = (0,src_core_hooks_useBgColor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const getAvatarStyles = (skin, skinColor)=>{
        let avatarStyles;
        if (skin === "light") {
            avatarStyles = {
                ...bgColors["".concat(skinColor, "Light")]
            };
        } else if (skin === "light-static") {
            avatarStyles = {
                color: bgColors["".concat(skinColor, "Light")].color,
                backgroundColor: (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_4__/* .lighten */ .$n)(theme.palette[skinColor].main, 0.88)
            };
        } else {
            avatarStyles = {
                ...bgColors["".concat(skinColor, "Filled")]
            };
        }
        return avatarStyles;
    };
    const colors = {
        primary: getAvatarStyles(skin, "primary"),
        secondary: getAvatarStyles(skin, "secondary"),
        success: getAvatarStyles(skin, "success"),
        error: getAvatarStyles(skin, "error"),
        warning: getAvatarStyles(skin, "warning"),
        info: getAvatarStyles(skin, "info")
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Avatar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        ref: ref,
        ...props,
        sx: !src && skin && color ? Object.assign(colors[color], sx) : sx
    });
});
Avatar.defaultProps = {
    skin: "filled",
    color: "primary"
};
/* harmony default export */ __webpack_exports__["Z"] = (Avatar);


/***/ }),

/***/ 66136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SettingsConsumer": function() { return /* binding */ SettingsConsumer; },
/* harmony export */   "SettingsContext": function() { return /* binding */ SettingsContext; },
/* harmony export */   "SettingsProvider": function() { return /* binding */ SettingsProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30152);
// ** React Imports


// ** ThemeConfig Import

const initialSettings = {
    themeColor: "primary",
    mode: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].mode,
    skin: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].skin,
    footer: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].footer,
    layout: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].layout,
    lastLayout: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].layout,
    direction: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].direction,
    navHidden: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].navHidden,
    appBarBlur: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].appBarBlur,
    navCollapsed: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].navCollapsed,
    contentWidth: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].contentWidth,
    toastPosition: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].toastPosition,
    verticalNavToggleType: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].verticalNavToggleType,
    appBar: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].layout === "horizontal" && src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].appBar === "hidden" ? "fixed" : src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].appBar
};
const staticSettings = {
    appBar: initialSettings.appBar,
    footer: initialSettings.footer,
    layout: initialSettings.layout,
    navHidden: initialSettings.navHidden,
    lastLayout: initialSettings.lastLayout,
    toastPosition: initialSettings.toastPosition
};
const restoreSettings = ()=>{
    let settings = null;
    try {
        const storedData = window.localStorage.getItem("settings");
        if (storedData) {
            settings = {
                ...JSON.parse(storedData),
                ...staticSettings
            };
        } else {
            settings = initialSettings;
        }
    } catch (err) {
        ;
    }
    return settings;
};
// set settings in localStorage
const storeSettings = (settings)=>{
    const initSettings = Object.assign({}, settings);
    delete initSettings.appBar;
    delete initSettings.footer;
    delete initSettings.layout;
    delete initSettings.navHidden;
    delete initSettings.lastLayout;
    delete initSettings.toastPosition;
    window.localStorage.setItem("settings", JSON.stringify(initSettings));
};
// ** Create Context
const SettingsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    saveSettings: ()=>null,
    settings: initialSettings
});
const SettingsProvider = (param)=>{
    let { children , pageSettings  } = param;
    // ** State
    const [settings, setSettings] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        ...initialSettings
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const restoredSettings = restoreSettings();
        if (restoredSettings) {
            setSettings({
                ...restoredSettings
            });
        }
        if (pageSettings) {
            setSettings({
                ...settings,
                ...pageSettings
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageSettings
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (settings.layout === "horizontal" && settings.mode === "semi-dark") {
            saveSettings({
                ...settings,
                mode: "light"
            });
        }
        if (settings.layout === "horizontal" && settings.appBar === "hidden") {
            saveSettings({
                ...settings,
                appBar: "fixed"
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        settings.layout
    ]);
    const saveSettings = (updatedSettings)=>{
        storeSettings(updatedSettings);
        setSettings(updatedSettings);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SettingsContext.Provider, {
        value: {
            settings,
            saveSettings
        },
        children: children
    });
};
const SettingsConsumer = SettingsContext.Consumer;


/***/ }),

/***/ 19550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2734);
/* harmony import */ var src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5026);
// ** MUI Imports

// ** Util Import

const UseBgColor = ()=>{
    // ** Hooks
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    return {
        primaryFilled: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main
        },
        primaryLight: {
            color: theme.palette.primary.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.primary.main, 0.12)
        },
        secondaryFilled: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main
        },
        secondaryLight: {
            color: theme.palette.secondary.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.secondary.main, 0.12)
        },
        successFilled: {
            color: theme.palette.success.contrastText,
            backgroundColor: theme.palette.success.main
        },
        successLight: {
            color: theme.palette.success.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.success.main, 0.12)
        },
        errorFilled: {
            color: theme.palette.error.contrastText,
            backgroundColor: theme.palette.error.main
        },
        errorLight: {
            color: theme.palette.error.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.error.main, 0.12)
        },
        warningFilled: {
            color: theme.palette.warning.contrastText,
            backgroundColor: theme.palette.warning.main
        },
        warningLight: {
            color: theme.palette.warning.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.warning.main, 0.12)
        },
        infoFilled: {
            color: theme.palette.info.contrastText,
            backgroundColor: theme.palette.info.main
        },
        infoLight: {
            color: theme.palette.info.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.info.main, 0.12)
        }
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (UseBgColor);


/***/ }),

/***/ 51514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useSettings; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_core_context_settingsContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66136);


const useSettings = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_core_context_settingsContext__WEBPACK_IMPORTED_MODULE_1__.SettingsContext);


/***/ }),

/***/ 59882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oS": function() { return /* binding */ formatDateToMonthShort; }
/* harmony export */ });
/* unused harmony exports formatDate, formatCreditCardNumber, formatExpirationDate, formatCVC */
/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */ // ** Checks if the passed date is today
const isToday = (date)=>{
    const today = new Date();
    return new Date(date).getDate() === today.getDate() && new Date(date).getMonth() === today.getMonth() && new Date(date).getFullYear() === today.getFullYear();
};
const formatDate = function(value) {
    let formatting = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        month: "short",
        day: "numeric",
        year: "numeric"
    };
    if (!value) return value;
    return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};
// ** Returns short month of passed date
const formatDateToMonthShort = function(value) {
    let toTimeForCurrentDay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    const date = new Date(value);
    let formatting = {
        month: "short",
        day: "numeric"
    };
    if (toTimeForCurrentDay && isToday(date)) {
        formatting = {
            hour: "numeric",
            minute: "numeric"
        };
    }
    return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};
// ? The following functions are taken from https://codesandbox.io/s/ovvwzkzry9?file=/utils.js for formatting credit card details
// Get only numbers from the input value
const clearNumber = function() {
    let value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return value.replace(/\D+/g, "");
};
// Format credit cards according to their types
const formatCreditCardNumber = (value, Payment)=>{
    if (!value) {
        return value;
    }
    const issuer = Payment.fns.cardType(value);
    const clearValue = clearNumber(value);
    let nextValue;
    switch(issuer){
        case "amex":
            nextValue = "".concat(clearValue.slice(0, 4), " ").concat(clearValue.slice(4, 10), " ").concat(clearValue.slice(10, 15));
            break;
        case "dinersclub":
            nextValue = "".concat(clearValue.slice(0, 4), " ").concat(clearValue.slice(4, 10), " ").concat(clearValue.slice(10, 14));
            break;
        default:
            nextValue = "".concat(clearValue.slice(0, 4), " ").concat(clearValue.slice(4, 8), " ").concat(clearValue.slice(8, 12), " ").concat(clearValue.slice(12, 19));
            break;
    }
    return nextValue.trim();
};
// Format expiration date in any credit card
const formatExpirationDate = (value)=>{
    const finalValue = value.replace(/^([1-9]\/|[2-9])$/g, "0$1/") // 3 > 03/
    .replace(/^(0[1-9]|1[0-2])$/g, "$1/") // 11 > 11/
    .replace(/^([0-1])([3-9])$/g, "0$1/$2") // 13 > 01/3
    .replace(/^(0?[1-9]|1[0-2])([0-9]{2})$/g, "$1/$2") // 141 > 01/41
    .replace(/^([0]+)\/|[0]+$/g, "0") // 0/ > 0 and 00 > 0
    // To allow only digits and `/`
    .replace(/[^\d\/]|^[\/]*$/g, "").replace(/\/\//g, "/") // Prevent entering more than 1 `/`
    ;
    return finalValue;
};
// Format CVC in any credit card
const formatCVC = (value, cardNumber, Payment)=>{
    const clearValue = clearNumber(value);
    const issuer = Payment.fns.cardType(cardNumber);
    const maxLength = issuer === "amex" ? 4 : 3;
    return clearValue.slice(0, maxLength);
};


/***/ }),

/***/ 83552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ getInitials; }
/* harmony export */ });
// ** Returns initials from string
const getInitials = (string)=>string.split(/\s/).reduce((response, word)=>response += word.slice(0, 1), "");


/***/ }),

/***/ 5026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ hexToRGBA; }
/* harmony export */ });
/**
 ** Hex color to RGBA color
 */ const hexToRGBA = (hexCode, opacity)=>{
    let hex = hexCode.replace("#", "");
    if (hex.length === 3) {
        hex = "".concat(hex[0]).concat(hex[0]).concat(hex[1]).concat(hex[1]).concat(hex[2]).concat(hex[2]);
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(opacity, ")");
};


/***/ }),

/***/ 96665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);




const NoData = ()=>{
    const { t , locale  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common");
    const [text, setText] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [text2, setText2] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [href, setHref] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [hrefText, setHrefText] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const path = window.location.pathname;
        if (path.indexOf("android") != -1) {
            if (path.indexOf("android/local") != -1) {
                setText(t("If there is no data for only some of the features please go to the"));
                setText2(t("page to check Also the app cant track social media data before connection so please be patient if the app is fully authorized"));
                setHrefText(t("Permission check"));
                setHref("".concat("https://test-ms-dashboard.gbyte.com.cn", "/android/local/permission-check"));
                ;
            } else {
                setText(t("Please enable Google backup See"));
                setText2(t("for details"));
                setHrefText(t("here"));
            // if (locale && locale != 'en') {
            //   setHref(
            //     '/guide/back-up-android' + '-' + (locale == 'it-ch' ? 'it' : locale)
            //   )
            // } else {
            //   setHref('/guide/back-up-android')
            // }
            }
        } else {
            setText(t("Please enable iCloud backup See"));
            setText2(t("for details"));
            setHrefText(t("here"));
        // if (locale && locale != 'en') {
        //   setHref('/guide/back-up-ios' + '-' + (locale == 'it-ch' ? 'it' : locale))
        // } else {
        //   setHref('/guide/back-up-ios')
        // }
        }
    }, [
        locale,
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "!h-[calc(var(--vh2)*100-240px)] smj:!h-[calc(var(--vh2)*100-115px)] w-full mt-5 [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] bg-white flex justify-center items-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center px-2",
                children: [
                    t("It appears theres no data to show here yet"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    t("If data exists it may take up to 1 hour to download and appear"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    t("We suggest checking back in a little while")
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoData);


/***/ }),

/***/ 30152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Config
 * -------------------------------------------------------------------------------------
 * ! IMPORTANT: Make sure you clear the browser local storage in order to see the config changes in the template.
 * ! To clear local storage, you may refer https://www.leadshook.com/help/how-to-clear-local-storage-in-google-chrome-browser/.
 */ const themeConfig = {
    // ** Layout Configs
    templateName: "Msafely" /* App Name */ ,
    layout: "vertical" /* vertical | horizontal */ ,
    mode: "light" /* light | dark | semi-dark /*! Note: semi-dark value will only work for Vertical Layout */ ,
    direction: "ltr" /* ltr | rtl */ ,
    skin: "default" /* default | bordered */ ,
    contentWidth: "boxed" /* full | boxed */ ,
    footer: "static" /* fixed | static | hidden */ ,
    // ** Routing Configs
    routingLoader: false,
    // ** Navigation (Menu) Configs
    navHidden: false,
    menuTextTruncate: true,
    navSubItemIcon: "mdi:circle" /* Icon */ ,
    verticalNavToggleType: "accordion" /* accordion | collapse /*! Note: This is for Vertical navigation menu only */ ,
    navCollapsed: false,
    navigationSize: 300 /* Number in px(Pixels) /*! Note: This is for Vertical navigation menu only */ ,
    collapsedNavigationSize: 68 /* Number in px(Pixels) /*! Note: This is for Vertical navigation menu only */ ,
    afterVerticalNavMenuContentPosition: "fixed" /* fixed | static */ ,
    beforeVerticalNavMenuContentPosition: "fixed" /* fixed | static */ ,
    horizontalMenuToggle: "hover" /* click | hover /*! Note: This is for Horizontal navigation menu only */ ,
    horizontalMenuAnimation: true,
    // ** AppBar Configs
    appBar: "fixed" /* fixed | static | hidden /*! Note: hidden value will only work for Vertical Layout */ ,
    appBarBlur: true,
    // ** Other Configs
    responsiveFontSizes: true,
    disableRipple: false,
    disableCustomizer: false,
    toastPosition: "top-right" /* top-left | top-center | top-right | bottom-left | bottom-center | bottom-right */ 
};
/* harmony default export */ __webpack_exports__["default"] = (themeConfig);


/***/ }),

/***/ 9644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useExtremeFeatureAccessGate; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var src_utils_iosIcloudBindStatus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66017);




/**
 * Extreme 功能页门控（仅 iOS-Cloud 有基础/高级绑定）
 *
 * - 未绑定高级：跳转 /ios/extreme-verification
 * - 已绑未购：出升级弹窗
 * - resetTime 未就绪：gatePending
 */ function useExtremeFeatureAccessGate(hasExtremePlan) {
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const resetTime = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((state)=>state.Common.resetTime);
    const currentMode = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((state)=>state.Common.currentMode);
    const deviceSwitchRevision = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((state)=>state.Common.deviceSwitchRevision);
    const isIos = (0,src_utils_iosIcloudBindStatus__WEBPACK_IMPORTED_MODULE_3__/* .shouldApplyIosExtremeBindGate */ .yI)(currentMode);
    const resetTimePending = isIos && (0,src_utils_iosIcloudBindStatus__WEBPACK_IMPORTED_MODULE_3__/* .isResetTimePending */ .z6)(resetTime);
    const advancedNotBound = isIos && (0,src_utils_iosIcloudBindStatus__WEBPACK_IMPORTED_MODULE_3__/* .isAdvancedVerificationIncomplete */ .dU)(resetTime);
    const extremePlan = hasExtremePlan === true || hasExtremePlan === "true";
    const gatePending = resetTimePending;
    const needsExtremeBindPage = isIos && !gatePending && advancedNotBound;
    const showUpgradeModal = isIos && !gatePending && !advancedNotBound && !extremePlan;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!needsExtremeBindPage) return;
        if (router.pathname === "/ios/extreme-verification") return;
        router.replace("/ios/extreme-verification");
    }, [
        needsExtremeBindPage,
        router,
        deviceSwitchRevision
    ]);
    return {
        resetTimePending,
        gatePending,
        advancedNotOver: advancedNotBound,
        needsExtremeBindPage,
        showUpgradeModal
    };
}


/***/ }),

/***/ 57921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useExtremeUpgradeRefresh; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_constants_extremeUpgrade__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76919);


/**
 * 订阅 Extreme 升级成功事件，刷新「当前所在功能页」的数据与 advanced 状态。
 *
 * 使用场景：页面内嵌了 ExtremeModal，用户在不离开页面的情况下完成升级后，
 * 需要去掉模糊遮罩并重新请求本页接口（如 smsChat-summary / getAllDashboard 等）。
 *
 * 刷新顺序（与 spyx / 后端缓存策略对齐）：
 * 1. notifyExtremeUpgraded 内已 await USER_SUMMARY 预缓冲（触发后台 advanced 同步）
 * 2. 本 hook 再 await primeExtremeAdvancedCache（二次预热，读到同步后的 advanced）
 * 3. 再执行 onUpgraded → 本页业务详情接口，用返回的 advanced 解锁 UI
 *
 * 注意：
 * - onUpgraded 内应复用「设备切换」时的重置 + 拉数逻辑（与 useDeviceScopedInit 保持一致）
 * - 建议先 setAdvanced(true) 乐观解锁 UI，再 dispatch 拉真实数据
 * - onUpgraded 可为 async；须 useCallback 包裹，避免重复注册监听
 *
 * @param {() => void | Promise<void>} onUpgraded - 升级成功后的刷新回调
 *
 * @example
 * useExtremeUpgradeRefresh(
 *   useCallback(() => {
 *     setAdvanced(true)
 *     dispatch(fetchUserProfile()) // hook 内已先 USER_SUMMARY，再执行此处
 *   }, [dispatch])
 * )
 */ function useExtremeUpgradeRefresh(onUpgraded) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!onUpgraded) return;
        const handler = async ()=>{
            await (0,src_constants_extremeUpgrade__WEBPACK_IMPORTED_MODULE_1__/* .primeExtremeAdvancedCache */ .ti)();
            await Promise.resolve(onUpgraded());
        };
        window.addEventListener(src_constants_extremeUpgrade__WEBPACK_IMPORTED_MODULE_1__/* .EXTREME_UPGRADED_EVENT */ .zp, handler);
        return ()=>window.removeEventListener(src_constants_extremeUpgrade__WEBPACK_IMPORTED_MODULE_1__/* .EXTREME_UPGRADED_EVENT */ .zp, handler);
    }, [
        onUpgraded
    ]);
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useExtremeUpgradeRefresh)));


/***/ }),

/***/ 98536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_we_chat; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useExtremeUpgradeRefresh.js
var useExtremeUpgradeRefresh = __webpack_require__(57921);
// EXTERNAL MODULE: ./src/utils/i18n.js + 1 modules
var i18n = __webpack_require__(61906);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box_Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/@core/hooks/useSettings.js
var useSettings = __webpack_require__(51514);
// EXTERNAL MODULE: ./src/@core/utils/get-initials.js
var get_initials = __webpack_require__(83552);
// EXTERNAL MODULE: ./src/@core/utils/format.js
var format = __webpack_require__(59882);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/Badge/Badge.js + 2 modules
var Badge = __webpack_require__(19529);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 2 modules
var Drawer = __webpack_require__(77533);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 3 modules
var ListItem = __webpack_require__(97212);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(46483);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemAvatar/ListItemAvatar.js + 1 modules
var ListItemAvatar = __webpack_require__(18987);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemButton/ListItemButton.js
var ListItemButton = __webpack_require__(98619);
// EXTERNAL MODULE: ./node_modules/react-perfect-scrollbar/lib/index.js
var lib = __webpack_require__(51964);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/store/apps/we-chat/index.js
var we_chat = __webpack_require__(82130);
// EXTERNAL MODULE: ./src/@core/components/icon/index.js
var icon = __webpack_require__(21609);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@iconify/react/dist/iconify.mjs
var iconify = __webpack_require__(1954);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/@api/dashboard.js
var dashboard = __webpack_require__(95629);
// EXTERNAL MODULE: ./src/components/NoData/index.js
var NoData = __webpack_require__(96665);
// EXTERNAL MODULE: ./src/store/apps/Common/index.js
var Common = __webpack_require__(34745);
;// CONCATENATED MODULE: ./src/@core/components/we-chat/side-bar.js
// ** React Imports



// ** Next Import

// ** MUI Imports













// ** Third Party Components



// ** Icon Imports

// ** Custom Components Import







const ScrollWrapper = (param)=>{
    let { children , hidden , list  } = param;
    const store = useSelector((state)=>state.WeChat);
    const dispatch = useDispatch();
    const [flag, setFlag] = useState(false);
    if (hidden) {
        return /*#__PURE__*/ _jsx(Box, {
            sx: {
                height: "100%",
                overflow: "auto"
            },
            children: /*#__PURE__*/ _jsxs(PerfectScrollbar, {
                options: {
                    wheelPropagation: false
                },
                onYReachEnd: (container)=>{
                    if (store.leftTotalCount == store.list.length + 20) return;
                    dispatch(fetchUserProfile());
                    setFlag(true);
                    setTimeout(()=>{
                        setFlag(false);
                    }, 2000);
                },
                children: [
                    children,
                    flag ? /*#__PURE__*/ _jsx("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ _jsx(Spin, {})
                    }) : null
                ]
            })
        });
    } else {
        return /*#__PURE__*/ _jsxs(PerfectScrollbar, {
            options: {
                wheelPropagation: false
            },
            onYReachEnd: (container)=>{
                if (store.leftTotalCount <= store.list.length + 20) return;
                dispatch(fetchUserProfile());
                setFlag(true);
                setTimeout(()=>{
                    setFlag(false);
                }, 2000);
            },
            children: [
                children,
                flag ? /*#__PURE__*/ _jsx("div", {
                    style: {
                        display: "flex",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ _jsx(Spin, {})
                }) : null
            ]
        });
    }
};
const WeChatSideBar = (props)=>{
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    // ** Props
    const { store , hidden , mdAbove , dispatch , selectMessage , sidebarWidth , leftSidebarOpen , handleLeftSidebarToggle , calls , setCalls , headImg , setHaedImg , setChat , setContacts , contacts , setLeftScrollTop , leftScrollTop , advanced  } = props;
    // ** States
    const [canLoad, setCanLoad] = (0,react.useState)(false);
    const [active, setActive] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (!canLoad) {
            if (store && store.list.length > 0) {
                setCanLoad(true);
                setActive(store.list[0].wxid);
            }
        }
    }, [
        store,
        canLoad
    ]);
    //从进入这个js开始，只加载一次
    // ** Hooks
    const router = (0,next_router.useRouter)();
    const handleChatClick = (item)=>{
        if (item.wxid === active) {
            if (!mdAbove && advanced) {
                handleLeftSidebarToggle();
            }
        } else {
            setActive(item.wxid);
            if (advanced) {
                if (domRef.current) setLeftScrollTop(domRef.current.scrollTop);
                dispatch((0,we_chat/* selectChat */.Z1)(item));
                localStorage.setItem("weChatItem", JSON.stringify(item));
                handleLeftSidebarToggle();
            }
        }
    };
    const [currentTime, setCurrentTime] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        const updateTime = ()=>{
            const list = store.list // 假设 store.list 已经定义并包含数据
            ;
            // 获取当前日期
            const now = new Date();
            const currentYear = now.getFullYear();
            const currentMonth = now.getMonth() + 1 // JavaScript 中月份从 0 开始
            ;
            const currentDate = now.getDate();
            // 遍历列表中的时间戳
            const formattedTimestamps = list.map((item)=>{
                const date = new Date(item.snippetTimestamp * 1000);
                // 获取时间戳的年、月、日
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                const day = date.getDate();
                let formattedDate = "";
                if (year === currentYear) {
                    if (month === currentMonth && day === currentDate) {
                        // 当年份、月份和日期都相同时，设置为 HH:mm:ss
                        formattedDate = "".concat(String(date.getHours()).padStart(2, "0"), ":").concat(String(date.getMinutes()).padStart(2, "0"), ":").concat(String(date.getSeconds()).padStart(2, "0"));
                    } else {
                        // 当年份相同但月份或日期不同，设置为 MM-DD
                        formattedDate = "".concat(String(month).padStart(2, "0"), "/").concat(String(day).padStart(2, "0"));
                    }
                } else {
                    // 当年份不同，设置为 YYYY-MM-DD
                    formattedDate = "".concat(year, "/").concat(String(month).padStart(2, "0"), "/").concat(String(day).padStart(2, "0"));
                }
                return formattedDate;
            });
            // 将所有格式化后的日期拼接成一个字符串并设置为 currentTime
            setCurrentTime(formattedTimestamps);
        };
        updateTime() // 初次渲染时更新时间
        ;
    }, [
        store.list
    ]);
    const domRef = (0,react.useRef)();
    const [scroll, setScroll] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        if (!domRef.current) return;
        const dom = domRef.current;
        const func = ()=>{
            const clientHeight = dom.clientHeight;
            const scrollTop = dom.scrollTop;
            const scrollHeight = dom.scrollHeight;
            const progress = (scrollTop / (scrollHeight - clientHeight) * 100).toFixed(0);
            setScroll(progress);
        };
        dom.addEventListener("scroll", func);
        return ()=>{
            dom.removeEventListener("scroll", func);
        };
    }, [
        canLoad,
        leftSidebarOpen
    ]);
    (0,react.useEffect)(()=>{
        if (scroll >= 100 && advanced) dispatch((0,we_chat/* fetchUserProfile */.YI)());
    }, [
        scroll
    ]);
    const renderChats = (0,react.useMemo)(()=>{
        if (store) {
            dispatch((0,Common/* changeExtremeService */.xU)(store.advanced === true || store.advanced === "true")) // 更新高级服务状态
            ;
            if (store.list && store.list.length) {
                return store.list.map((item, index)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                        disablePadding: true,
                        sx: {
                            "&:not(:last-child)": {
                                mb: 1.5
                            },
                            borderRadius: "10px"
                        },
                        className: "".concat(!advanced ? "blur-[16px] select-none" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton/* default */.Z, {
                            disableRipple: true,
                            onClick: ()=>handleChatClick(item),
                            sx: {
                                px: 2.5,
                                py: 2.5,
                                borderRadius: "8px",
                                width: "100%",
                                borderRadius: 1,
                                alignItems: "flex-start",
                                ...item.wxid === active && {
                                    backgroundColor: (theme)=>"".concat(theme.palette.primary.main, " !important")
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar/* default */.Z, {
                                    sx: {
                                        m: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                        overlap: "circular",
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "right"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                            src: item.avata != "" ? item.avata : item.defaultAvata,
                                            sx: {
                                                width: 40,
                                                height: 40,
                                                outline: (theme)=>"2px solid ".concat(item.wxid === active ? theme.palette.common.white : "transparent")
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    sx: {
                                        my: 0,
                                        ml: 4,
                                        mr: 1.5,
                                        "& .MuiTypography-root": {
                                            ...item.wxid === active && {
                                                color: "common.white"
                                            }
                                        }
                                    },
                                    primary: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        noWrap: true,
                                        sx: {
                                            ...item.wxid !== active ? {
                                                color: "text.secondary"
                                            } : {}
                                        },
                                        children: item.chatname
                                    }),
                                    secondary: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        noWrap: true,
                                        variant: "body2",
                                        sx: {
                                            ...item.wxid !== active && {
                                                color: "text.disabled"
                                            }
                                        },
                                        children: item.snippet
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        alignItems: "flex-end",
                                        flexDirection: "column",
                                        justifyContent: "flex-start"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            whiteSpace: "nowrap",
                                            color: item.wxid === active ? "common.white" : "#808080",
                                            fontSize: "10px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: currentTime[index]
                                        })
                                    })
                                })
                            ]
                        })
                    }, index);
                });
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            color: "text.secondary",
                            width: "100%",
                            opacity: "0.7",
                            textAlign: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoData/* default */.Z, {})
                    })
                });
            }
        }
    }, [
        store.list,
        active
    ]);
    (0,react.useEffect)(()=>{
        if (leftSidebarOpen && domRef.current) domRef.current.scrollTop = leftScrollTop;
    }, [
        leftSidebarOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: canLoad ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
                open: leftSidebarOpen,
                onClose: handleLeftSidebarToggle,
                variant: mdAbove ? "permanent" : "temporary",
                ModalProps: {
                    disablePortal: true,
                    keepMounted: false // Better open performance on mobile.
                },
                sx: {
                    zIndex: 7,
                    height: "100%",
                    display: "block",
                    position: mdAbove ? "static" : "absolute",
                    "& .MuiDrawer-paper": {
                        boxShadow: "none",
                        overflow: "hidden",
                        width: sidebarWidth,
                        position: mdAbove ? "static" : "absolute"
                    },
                    "& > .MuiBackdrop-root": {
                        borderRadius: 1,
                        position: "absolute",
                        zIndex: (theme)=>theme.zIndex.drawer - 1
                    },
                    "& .MuiPaper-root": {
                        borderTopRightRadius: {
                            xs: "10px",
                            md: "0px" // 大于等于900px时
                        },
                        borderBottomRightRadius: {
                            xs: "10px",
                            md: "0px" // 大于等于900px时
                        },
                        borderTopLeftRadius: "10px",
                        borderBottomLeftRadius: "10px"
                    }
                },
                className: "".concat(advanced ? "border-r-[1px]" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center justify-between px-4 pt-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/dashboard/new-android/wechat.svg",
                                width: 10,
                                height: 10,
                                alt: "logo",
                                className: "w-[30px] h-[30px]"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                p: (theme)=>theme.spacing(2, 3, 0),
                                "&::-webkit-scrollbar": {
                                    width: "6px" // 设置滚动条的宽度
                                },
                                "&::-webkit-scrollbar-track": {
                                    backgroundColor: "#f0f0f0" // 滚动条的背景色
                                },
                                "&::-webkit-scrollbar-thumb": {
                                    backgroundColor: "#999",
                                    borderRadius: "10px" // 滑块的圆角
                                },
                                "&::-webkit-scrollbar-thumb:hover": {
                                    backgroundColor: "#666" // 当鼠标悬停在滑块上时的颜色
                                },
                                height: "100%"
                            },
                            className: "".concat(advanced ? "overflow-auto" : "overflow-hidden"),
                            ref: domRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                sx: {
                                    mb: 7.5,
                                    p: 0,
                                    mt: 4
                                },
                                className: "h-full ".concat(!advanced ? "blur-[16px] select-none" : ""),
                                children: renderChats
                            })
                        })
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
    });
};
/* harmony default export */ var side_bar = (WeChatSideBar);

// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/google-map-react/dist/index.modern.js + 1 modules
var index_modern = __webpack_require__(28499);
// EXTERNAL MODULE: ./src/@core/components/mui/avatar/index.js
var avatar = __webpack_require__(92024);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js + 5 modules
var spin = __webpack_require__(57381);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 27 modules
var modal = __webpack_require__(60770);
// EXTERNAL MODULE: ./src/utils/byteConversion.js
var byteConversion = __webpack_require__(70640);
;// CONCATENATED MODULE: ./src/@core/components/we-chat/log.js
// ** React Imports



// ** MUI Imports



// ** Icon Imports

// ** Third Party Components

// ** Utils Imports









const log_PerfectScrollbar = (0,styled/* default */.ZP)((lib_default()))((param)=>{
    let { theme  } = param;
    return {
        padding: theme.spacing(5)
    };
});
const AnyReactComponent = (param)=>/*#__PURE__*/ {
    let { text  } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: " ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative flex ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " absolute w-[180px] h-[40px] -mt-8 -ml-[70px] text-[13px] flex items-center text-center text-[#4d5976] text-opacity-90 font-[500] bg-white rounded-lg",
                    children: text
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute flex items-center justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                        icon: "material-symbols:location-on-rounded",
                        width: 50,
                        height: 50,
                        className: "text-[#FF5252]"
                    })
                })
            ]
        })
    });
};
const MessagesLog = (props)=>{
    // ** Props
    const { hidden , advanced  } = props;
    const data = (0,es/* useSelector */.v9)((state)=>state.WeChat.selectedMessage);
    const [flag, setFlag] = (0,react.useState)(false);
    // ** Ref
    const chatArea = (0,react.useRef)(null);
    // ** Scroll to chat bottom
    const scrollToBottom = ()=>{
        if (chatArea.current) {
            if (chatArea.current._container.scrollTop == 0) {
                setTimeout(()=>{
                    chatArea.current._container.scrollTop = Number.MAX_SAFE_INTEGER;
                }, 2000);
            }
            if (hidden) {
                // @ts-ignore
                chatArea.current._container.scrollTop = Number.MAX_SAFE_INTEGER;
            // chatArea.current.scrollTop = Number.MAX_SAFE_INTEGER
            } else {
                // @ts-ignore
                chatArea.current._container.scrollTop = Number.MAX_SAFE_INTEGER;
            }
        }
    };
    // 记录首次加载
    const [isFirstLoad, setIsFirstLoad] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        if (data && data.selected && data.selected.length <= 50) {
            scrollToBottom();
            setIsFirstLoad(false);
        } else {
            if (chatArea.current) {
                if (hidden) {
                    // @ts-ignore
                    chatArea.current._container.scrollTop = 20;
                } else {
                    // @ts-ignore
                    chatArea.current._container.scrollTop = 20;
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // ** Renders user chat
    const renderChats = ()=>{
        if (data.selected.length == 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    background: "#F5F5F5",
                    fontSize: "26px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#666",
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoData/* default */.Z, {})
            });
        }
        return data.selected.map((item, index)=>{
            const isSender = item.isFromMe;
            const time = dayjs_min_default()(Number(item.date + "000")).format("YY-MM-DD HH:mm");
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        className: "row-item",
                        sx: {
                            display: "flex",
                            flexDirection: !item.isFromMe ? "row" : "row-reverse"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            className: "chat-body",
                            sx: {
                                maxWidth: [
                                    "calc(100% - 5.75rem)",
                                    "75%",
                                    "65%"
                                ],
                                minWidth: "74px",
                                position: "relative"
                            },
                            style: {
                                maxWidth: item.messageType === 10000 ? "100%" : "",
                                width: item.messageType === 10000 ? "100%" : ""
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    "&:not(:last-of-type)": {
                                        mb: 3.5
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "",
                                    style: {
                                        display: "flex"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            borderRadius: 1,
                                            p: (theme)=>theme.spacing(0, 2),
                                            ml: isSender ? "auto" : undefined,
                                            borderTopLeftRadius: !isSender ? 0 : undefined,
                                            borderTopRightRadius: isSender ? 0 : undefined,
                                            color: isSender ? "black" : "text.primary",
                                            backgroundColor: isSender ? "#D1FAE5" : "#ffffff",
                                            mb: 4.4,
                                            mt: 2,
                                            boxShadow: item.messageType === 10000 ? "unset" : 1,
                                            width: item.messageType === 10000 ? "100%" : "fit-content 80%"
                                        },
                                        children: (()=>{
                                            try {
                                                if (item.messageType === 1) {
                                                    let text = "";
                                                    let pic = "";
                                                    let name = "";
                                                    try {
                                                        if (store.members.length > 0) {
                                                            let str = item.text;
                                                            let res = str.indexOf(":");
                                                            let content = str.substr(res + 1, str.length);
                                                            let userObj = store.members.find((row)=>row.wxid == str.substr(0, res));
                                                            text = "".concat(content);
                                                            name = "".concat(userObj.name);
                                                            pic = userObj.headImageUrl;
                                                        } else {
                                                            text = item.text;
                                                        }
                                                    } catch (error) {
                                                        text = item.text;
                                                    }
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex p-2 chat_box",
                                                        style: {
                                                            flexDirection: "column"
                                                        },
                                                        children: [
                                                            store.members.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    marginBottom: "4px",
                                                                    height: "24px",
                                                                    overflow: "hidden"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: pic,
                                                                        width: "20",
                                                                        height: "20",
                                                                        alt: "img",
                                                                        style: {
                                                                            borderRadius: "50%",
                                                                            width: "20px",
                                                                            height: "20px"
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        style: {
                                                                            marginLeft: "4px",
                                                                            color: "#4E4E4E"
                                                                        },
                                                                        children: [
                                                                            " ",
                                                                            name
                                                                        ]
                                                                    })
                                                                ]
                                                            }) : null,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "chat_box font-semibold text-[0.8rem] text-black text-opacity-80 chat_box",
                                                                    style: {
                                                                        display: "inline-block",
                                                                        wordBreak: "break-all",
                                                                        maxWidth: "400px",
                                                                        overflow: "hidden"
                                                                    },
                                                                    children: text
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "absolute bottom-0 right-0",
                                                                style: {
                                                                    width: "120px",
                                                                    left: !item.isFromMe ? "0" : "unset",
                                                                    right: item.isFromMe ? "0" : "unset"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    variant: "caption",
                                                                    sx: {
                                                                        color: "text.disabled"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "text-[#9CA3AF] text-[0.6rem]",
                                                                        children: time
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    });
                                                } else if (item.messageType === 3) {
                                                    if (item.attachment.type == "IMAGE") {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: " flex p-2 chat_box",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "font-semibold text-[0.8rem] text-black text-opacity-80",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            src: "https://cos.spyx.com/" + item.attachment.url,
                                                                            alt: "Picture of the author",
                                                                            width: 150,
                                                                            height: 150,
                                                                            style: {
                                                                                cursor: "pointer"
                                                                            },
                                                                            onClick: ()=>{
                                                                                dispatch((0,we_chat/* setPerViewImage */.CJ)({
                                                                                    open: true,
                                                                                    url: "https://cos.spyx.com/".concat(item.attachment.url)
                                                                                }));
                                                                            }
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "absolute bottom-0 right-0 ",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                        variant: "caption",
                                                                        sx: {
                                                                            color: "text.disabled"
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: " text-[#9CA3AF] text-[0.6rem] ",
                                                                            children: time
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        });
                                                    } else {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: " flex p-2 chat_box",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "font-semibold text-[0.8rem] text-black text-opacity-80",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                                                                            controls: true,
                                                                            autoPlay: false,
                                                                            id: "video",
                                                                            preload: "none",
                                                                            loop: false,
                                                                            muted: false,
                                                                            poster: "https://cos.spyx.com/" + item.attachment.cover_url,
                                                                            children: [
                                                                                "can not be used Video",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                                                    src: "https://cos.spyx.com/" + item.attachment.url,
                                                                                    type: "video/mp4"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                                                    src: "movie.ogg",
                                                                                    type: "video/ogg"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "absolute bottom-0 right-0 ",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                        variant: "caption",
                                                                        sx: {
                                                                            color: "text.disabled"
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: " text-[#9CA3AF] text-[0.6rem] ",
                                                                            children: time
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        });
                                                    }
                                                } else if (item.messageType === 34) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("audio", {
                                                            controls: true,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                                    src: "https://cos.spyx.com/" + item.attachment.url,
                                                                    type: "audio/mpeg"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("embed", {
                                                                    height: "50",
                                                                    width: "100",
                                                                    src: "https://cos.spyx.com/" + item.attachment.url
                                                                })
                                                            ]
                                                        })
                                                    });
                                                } else if (item.messageType === 42) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: " flex p-2 chat_box",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        style: {
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            alignItems: "center",
                                                                            padding: "10px 0px",
                                                                            paddingRight: "20px"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                style: {
                                                                                    width: "32px",
                                                                                    height: "32px",
                                                                                    borderRadius: "50%",
                                                                                    marginRight: "10px"
                                                                                },
                                                                                src: item.attachment.smallheadimgurl,
                                                                                width: "20",
                                                                                height: "20",
                                                                                alt: "img"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "chat_box font-semibold text-[0.8rem] text-black text-opacity-80 chat_box",
                                                                                style: {
                                                                                    display: "inline-block",
                                                                                    maxWidth: "400px",
                                                                                    overflow: "hidden"
                                                                                },
                                                                                children: item.attachment.nickname
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        style: {
                                                                            borderBottom: "1px"
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "absolute bottom-0 right-0",
                                                                style: {
                                                                    width: "120px",
                                                                    left: !item.isFromMe ? "0" : "unset",
                                                                    right: item.isFromMe ? "0" : "unset"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    variant: "caption",
                                                                    sx: {
                                                                        color: "text.disabled"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: " text-[#9CA3AF] text-[0.6rem] ",
                                                                        children: time
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    });
                                                } else if (item.messageType === 43 || item.messageType === 44 || item.messageType === 62) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: " flex p-2 chat_box",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "font-semibold text-[0.8rem] text-black text-opacity-80 ",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                                                                        controls: true,
                                                                        autoPlay: false,
                                                                        id: "video",
                                                                        preload: "none",
                                                                        loop: false,
                                                                        muted: false,
                                                                        poster: "https://cos.spyx.com/" + item.attachment.cover_url,
                                                                        children: [
                                                                            "can not be used Video",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                                                src: "https://cos.spyx.com/" + item.attachment.url,
                                                                                type: "video/mp4"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                                                src: "movie.ogg",
                                                                                type: "video/ogg"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "absolute bottom-0 right-0 ",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    variant: "caption",
                                                                    sx: {
                                                                        color: "text.disabled"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: " text-[#9CA3AF] text-[0.6rem] ",
                                                                        children: time
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    });
                                                } else if (item.messageType === 47) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: " flex p-2 chat_box",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "chat_box font-semibold text-[0.8rem] text-black text-opacity-80 chat_box",
                                                                    style: {
                                                                        display: "inline-block",
                                                                        maxWidth: "400px",
                                                                        overflow: "hidden"
                                                                    },
                                                                    children: item.text
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "absolute bottom-0 right-0",
                                                                style: {
                                                                    width: "120px",
                                                                    left: !item.isFromMe ? "0" : "unset",
                                                                    right: item.isFromMe ? "0" : "unset"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    variant: "caption",
                                                                    sx: {
                                                                        color: "text.disabled"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: " text-[#9CA3AF] text-[0.6rem] ",
                                                                        children: time
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    });
                                                } else if (item.messageType === 48) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        style: {
                                                            height: "270px",
                                                            width: "270px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* default */.ZP, {
                                                                bootstrapURLKeys: {
                                                                    key: "AIzaSyATBMz-vxnBoK1LIOxJYRRWjGbsA2VA0tY"
                                                                },
                                                                defaultCenter: {
                                                                    lat: Number(item.attachment.latitude),
                                                                    lng: Number(item.attachment.longitude)
                                                                },
                                                                defaultZoom: 15,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnyReactComponent, {
                                                                    lat: Number(item.attachment.latitude),
                                                                    lng: Number(item.attachment.longitude),
                                                                    text: item.attachment.label + item.attachment.poiname
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                variant: "caption",
                                                                sx: {
                                                                    color: "text.disabled"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: " text-[#9CA3AF] text-[0.6rem] ",
                                                                    children: time
                                                                })
                                                            })
                                                        ]
                                                    });
                                                } else if (item.messageType === 50) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: " flex p-2 chat_box",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "chat_box font-semibold text-[0.8rem] text-black text-opacity-80 chat_box",
                                                                    style: {
                                                                        display: "flex",
                                                                        maxWidth: "400px",
                                                                        overflow: "hidden"
                                                                    },
                                                                    children: [
                                                                        item.attachment.voip_msg,
                                                                        " ",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            style: {
                                                                                marginLeft: "4px"
                                                                            },
                                                                            children: item.attachment.type === "VOICE_CALL" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                                                icon: "material-symbols:call",
                                                                                width: 18,
                                                                                height: 18
                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                                                icon: "material-symbols:auto-videocam-outline-sharp",
                                                                                width: 18,
                                                                                height: 18
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "absolute bottom-0 right-0",
                                                                style: {
                                                                    width: "120px",
                                                                    left: !item.isFromMe ? "0" : "unset",
                                                                    right: item.isFromMe ? "0" : "unset"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    variant: "caption",
                                                                    sx: {
                                                                        color: "text.disabled"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: " text-[#9CA3AF] text-[0.6rem] ",
                                                                        children: time
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    });
                                                }
                                            } catch (error1) {
                                                ;
                                            }
                                        })()
                                    })
                                })
                            }, index)
                        })
                    }, item.PK + item.date + 1),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        className: "row-item",
                        style: {
                            color: "red"
                        },
                        children: item.messageType === 10000 || item.messageType === 10002 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "chat_box",
                            style: {
                                width: "100%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {},
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    style: {
                                        display: "inline-block",
                                        overflow: "hidden",
                                        color: "#757C86",
                                        textAlign: "center",
                                        width: "100%"
                                    },
                                    children: item.text
                                })
                            })
                        }) : null
                    }, item.PK + item.date + 2),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        className: "row-item",
                        sx: {
                            display: "flex",
                            flexDirection: !item.isFromMe ? "row" : "row-reverse",
                            marginBottom: "10px"
                        },
                        children: (()=>{
                            if (item.messageType === 49) {
                                if (item.attachment && item.attachment.type === "RED_PACKET") {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            width: "250px",
                                            height: "120px",
                                            backgroundImage: "linear-gradient(135deg,#D8AF7F,#EEAA59)",
                                            borderRadius: "8px",
                                            padding: "10px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    height: "84px",
                                                    borderBottom: "1px solid #E5B985",
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: item.attachment.iconurl,
                                                        alt: "packet",
                                                        width: "50",
                                                        height: "50"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            fontSize: "20px",
                                                            color: "#fff",
                                                            marginLeft: "10px"
                                                        },
                                                        children: item.attachment.sendertitle
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                style: {
                                                    fontSize: "12px",
                                                    color: "#fff",
                                                    lineHeight: "2"
                                                },
                                                children: "微信红包"
                                            })
                                        ]
                                    });
                                } else if (item.attachment && item.attachment.type === "TRANSFER") {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            width: "250px",
                                            height: "120px",
                                            backgroundImage: "linear-gradient(135deg,#D8AF7F,#EEAA59)",
                                            borderRadius: "8px",
                                            padding: "10px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    height: "84px",
                                                    borderBottom: "1px solid #E5B985",
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                        icon: "bi:exclamation-circle",
                                                        width: 50,
                                                        height: 50,
                                                        className: "text-[#fff]"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        style: {
                                                            fontSize: "20px",
                                                            color: "#fff",
                                                            marginLeft: "10px"
                                                        },
                                                        children: [
                                                            item.attachment.feedesc,
                                                            Number(item.attachment.invalidtime + "000") < new Date().getTime() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    fontSize: "14px"
                                                                },
                                                                children: "已过期"
                                                            }) : null
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                style: {
                                                    fontSize: "12px",
                                                    color: "#fff",
                                                    lineHeight: "2"
                                                },
                                                children: "微信转账"
                                            })
                                        ]
                                    });
                                } else if (item.attachment && item.attachment.type === "FILE") {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            width: "250px",
                                            height: "80px",
                                            background: "#fff",
                                            borderRadius: "8px",
                                            padding: "10px",
                                            display: "flex"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    width: "190px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        style: {
                                                            fontSize: "18px"
                                                        },
                                                        children: item.attachment.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        style: {
                                                            fontSize: "14px",
                                                            color: "#C7C7C7"
                                                        },
                                                        children: (0,byteConversion/* default */.Z)(item.attachment.totallen)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    width: "40px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                    icon: "ci:file-pdf",
                                                    width: 50,
                                                    height: 50,
                                                    className: "text-[#E43E51]"
                                                })
                                            })
                                        ]
                                    });
                                } else if (item.attachment && item.attachment.type === "LINK") {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: item.attachment.url,
                                        style: {
                                            width: "250px",
                                            height: "120px",
                                            background: "#fff",
                                            borderRadius: "8px",
                                            padding: "10px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                style: {
                                                    height: "50px",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: "2",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    display: "-webkit-box"
                                                },
                                                children: item.attachment.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                style: {
                                                    height: "50px",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: "2",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    display: "-webkit-box"
                                                },
                                                children: item.attachment.des
                                            })
                                        ]
                                    });
                                } else if (item.attachment && item.attachment.type === "CARD") {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            width: "250px",
                                            height: "68px",
                                            background: "#fff",
                                            borderRadius: "8px",
                                            padding: "10px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                style: {
                                                    height: "24px",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: "1",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    display: "-webkit-box",
                                                    fontSize: "18px"
                                                },
                                                children: item.attachment.des
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                style: {
                                                    height: "24px",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: "1",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    display: "-webkit-box",
                                                    fontSize: "16px"
                                                },
                                                children: item.attachment.brand_name
                                            })
                                        ]
                                    });
                                } else if (item.attachment && item.attachment.type === "MUSIC") {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: item.attachment.url,
                                        style: {
                                            width: "250px",
                                            height: "80px",
                                            background: "#fff",
                                            borderRadius: "8px",
                                            display: "flex",
                                            overflow: "hidden"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                alt: "qq music",
                                                width: "100",
                                                height: "100",
                                                src: item.attachment.songalbumurl,
                                                style: {
                                                    height: "100%",
                                                    width: "90px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    width: "calc(250px - 90px)",
                                                    background: "#6F7886",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    padding: "0 10px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    color: "#fff",
                                                                    WebkitBoxOrient: "vertical",
                                                                    WebkitLineClamp: "1",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    display: "-webkit-box"
                                                                },
                                                                children: item.attachment.title
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    fontSize: "14px",
                                                                    color: "#BBBBBB",
                                                                    WebkitBoxOrient: "vertical",
                                                                    WebkitLineClamp: "1",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    display: "-webkit-box"
                                                                },
                                                                children: item.attachment.des
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                            icon: "material-symbols:play-arrow-rounded",
                                                            width: 30,
                                                            height: 30,
                                                            className: "text-[#fff]"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                }
                            }
                        })()
                    }, item.PK + item.date + 3)
                ]
            });
        });
    };
    const store = (0,es/* useSelector */.v9)((state)=>state.WeChat);
    const dispatch = (0,es/* useDispatch */.I0)();
    const [scroll, setScroll] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        if (scroll >= 100) {
            if (store.selectedMessage.selected.length >= store.rightTotalCount) return;
            dispatch((0,we_chat/* selectChat */.Z1)());
            setFlag(true);
            setTimeout(()=>{
                setFlag(false);
            }, 1000);
        }
    }, [
        scroll
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    borderBottomLeftRadius: "8px",
                    borderBottomRightRadius: "8px"
                },
                className: "bg-bgImg h-auto flex-1 ".concat(advanced ? "overflow-y-auto" : "overflow-hidden"),
                children: hidden ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: advanced ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(log_PerfectScrollbar, {
                        ref: chatArea,
                        options: {
                            wheelPropagation: false,
                            suppressScrollX: true
                        },
                        onScrollY: (e)=>{
                            const progress = (e.scrollTop / (e.scrollHeight - e.clientHeight) * 100).toFixed(0);
                            if (!isFirstLoad && progress >= 75) {
                                setScroll(progress);
                            }
                        },
                        children: [
                            renderChats(),
                            flag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {})
                            }) : null
                        ]
                    }) : renderChats()
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: advanced ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(log_PerfectScrollbar, {
                        ref: chatArea,
                        options: {
                            wheelPropagation: false
                        },
                        onScrollY: (e)=>{
                            const progress = (e.scrollTop / (e.scrollHeight - e.clientHeight) * 100).toFixed(0);
                            if (!isFirstLoad && progress >= 75) {
                                setScroll(progress);
                            }
                        },
                        children: [
                            renderChats(),
                            flag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {})
                            }) : null
                        ]
                    }) : renderChats()
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                title: "",
                open: store.preViewImage.open,
                onCancel: ()=>{
                    dispatch((0,we_chat/* setPerViewImage */.CJ)({
                        open: false,
                        url: ""
                    }));
                },
                width: "540px",
                footer: [],
                zIndex: 1200,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        padding: "14px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: store.preViewImage.url,
                        width: 200,
                        height: 200,
                        style: {
                            width: "460px",
                            height: "auto"
                        },
                        alt: "preview"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var log = (MessagesLog);

;// CONCATENATED MODULE: ./src/@core/components/we-chat/content.js
// ** MUI Imports





// ** Icon Imports

// ** Custom Components Import



// ** Styled Components
const ChatWrapperStartChat = (0,styled/* default */.ZP)(Box_Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        flexGrow: 1,
        height: "100%",
        display: "flex",
        borderRadius: 1,
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: theme.palette.action.hover
    };
});
const KikContent = (props)=>{
    // ** Props
    const { store , hidden , mdAbove , handleLeftSidebarToggle , handleUserProfileRightSidebarToggle , headImg , advanced  } = props;
    const [canLoad, setCanLoad] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (!canLoad) {
            if (store && store.list.length > 0) {
                setCanLoad(true);
            }
        }
    }, [
        store,
        canLoad
    ]);
    const handleStartConversation = ()=>{
        if (!mdAbove) {
            handleLeftSidebarToggle();
        }
    };
    const renderContent = ()=>{
        if (!store) {
            return null // 如果 store 不存在，返回 null
            ;
        }
        const selectedMessage = store.selectedMessage;
        if (!canLoad) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatWrapperStartChat, {
                sx: {
                    ...mdAbove ? {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    } : {}
                },
                children: advanced && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    onClick: handleStartConversation,
                    sx: {
                        px: 6,
                        py: 2.25,
                        boxShadow: 3,
                        borderRadius: 5,
                        backgroundColor: "background.paper",
                        cursor: mdAbove ? "default" : "pointer"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            fontWeight: 600
                        },
                        children: "Start Conversation"
                    })
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
            sx: {
                flexGrow: 1,
                borderTopLeftRadius: {
                    xs: "8px",
                    md: null
                },
                borderTopRightRadius: {
                    xs: "8px",
                    md: "8px"
                },
                borderBottomLeftRadius: {
                    xs: "8px",
                    md: null
                },
                borderBottomRightRadius: {
                    xs: "8px",
                    md: "8px"
                }
            },
            className: "bg-[#FFFFFF] w-full flex-1 flex flex-col ".concat(!advanced ? "blur-[16px] select-none" : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        py: 3,
                        px: 5,
                        display: "flex",
                        alignItems: "center",
                        borderBottom: (theme)=>"1px solid ".concat(theme.palette.divider),
                        height: "68px"
                    },
                    className: "border-b-[1px] border-black border-opacity-10 justify-between overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "md:invisible flex-shrink-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/text-messages/return.svg",
                                width: 20,
                                height: 20,
                                alt: "return",
                                onClick: handleLeftSidebarToggle
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center flex-shrink-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/images/avatars/10.png",
                                    width: 40,
                                    height: 40,
                                    alt: "avatar"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "ml-[10px] text-[#000000] text-[14px] font-[600]",
                                    children: selectedMessage.contact.chatname
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "invisible w-[20px] h-[20px]"
                        })
                    ]
                }),
                selectedMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(log, {
                    hidden: hidden,
                    advanced: advanced,
                    data: {
                        ...selectedMessage
                    }
                }) : null
            ]
        });
    };
    return renderContent();
};
/* harmony default export */ var content = (KikContent);

// EXTERNAL MODULE: ./src/@core/components/modal/extreme-upgrade/index.js + 4 modules
var extreme_upgrade = __webpack_require__(3769);
// EXTERNAL MODULE: ./src/hooks/useExtremeFeatureAccessGate.js
var useExtremeFeatureAccessGate = __webpack_require__(9644);
;// CONCATENATED MODULE: ./src/pages/we-chat/index.js
// ** React Imports




// ** MUI Imports



// ** Store & Actions Imports

// ** Hooks

// ** Utils Imports


// ** Chat App Components Imports






const WeChat = ()=>{
    let Advanced = window.localStorage.getItem("Advanced");
    Advanced = Advanced == null || Advanced == 0 ? true : false;
    // ** States
    const [userStatus, setUserStatus] = (0,react.useState)("online");
    const [leftSidebarOpen, setLeftSidebarOpen] = (0,react.useState)(true);
    const [userProfileLeftOpen, setUserProfileLeftOpen] = (0,react.useState)(false);
    const [userProfileRightOpen, setUserProfileRightOpen] = (0,react.useState)(false);
    const [leftScrollTop, setLeftScrollTop] = (0,react.useState)(0);
    // ** Hooks
    const theme = (0,useTheme/* default */.Z)();
    const { settings  } = (0,useSettings/* useSettings */.r)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const hidden = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    const store = (0,es/* useSelector */.v9)((state)=>state.WeChat);
    const storeCommon = (0,es/* useSelector */.v9)((state)=>state.Common);
    // ** Vars
    const { skin  } = settings;
    const smAbove = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("sm"));
    const sidebarWidth = smAbove ? 370 : "100%";
    const mdAbove = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    const [chat, setChat] = (0,react.useState)(true);
    const [calls, setCalls] = (0,react.useState)(false);
    const [headImg, setHaedImg] = (0,react.useState)("/images/whatsapp/1.jpg");
    const [contacts, setContacts] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        dispatch((0,we_chat/* fetchUserProfile */.YI)());
    }, [
        dispatch
    ]);
    const handleLeftSidebarToggle = ()=>setLeftSidebarOpen((prev)=>!prev);
    const handleUserProfileLeftSidebarToggle = ()=>setUserProfileLeftOpen((prev)=>!prev);
    const handleUserProfileRightSidebarToggle = ()=>setUserProfileRightOpen((prev)=>!prev);
    const { t , locale  } = (0,i18n/* useTranslation */.$G)("common");
    (0,react.useEffect)(()=>{
        const title = t("WeChat");
        dispatch((0,Common/* setCurrentTab */.Lw)(title));
        return ()=>dispatch((0,Common/* setCurrentTab */.Lw)(""));
    }, [
        dispatch,
        locale
    ]);
    const [advanced, setAdvanced] = (0,react.useState)(true) // 是否购买高级服务
    ;
    const fetchLoading = [
        true,
        "true"
    ].includes(store.fetchLoading) // 数据获取中
    ;
    const basicNotOver = [
        null,
        ""
    ].includes(storeCommon.resetTime.basicUpdateDownloadTime) // 是否未完成一步验证
    ;
    const advancedNotOver = [
        null,
        ""
    ].includes(storeCommon.resetTime.advancedUpdateDownloadTime) // 高级数据未下载完成（空 = 未完成）
    ;
    // 高级功能门控（对齐 SpyX）：未绑高级 → 跳 /ios/extreme-verification；数据未就绪 → 暂停渲染
    const { gatePending , showUpgradeModal  } = (0,useExtremeFeatureAccessGate/* useExtremeFeatureAccessGate */.t)(advanced);
    const [justVerified, setJustVerified] = (0,react.useState)(false) // 是否为刚完成验证
    ;
    // 升级成功后：预缓冲已在 notify 完成，这里重拉详情读 advanced
    (0,useExtremeUpgradeRefresh/* useExtremeUpgradeRefresh */.v)((0,react.useCallback)(()=>{
        setAdvanced(true);
        dispatch((0,we_chat/* fetchUserProfile */.YI)());
    }, [
        dispatch
    ]));
    (0,react.useEffect)(()=>{
        setAdvanced(store.advanced === true || store.advanced === "true");
    }, [
        store
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative bg-[100px] flex justify-center Bxl:h-[calc(var(--vh2)*100-94px)] Bxls:Headers5:h-[calc(var(--vh2)*100-149px)] Header5:big:h-[calc(var(--vh2)*100-214px)] bigs:h-[calc(var(--vh2)*100-274px)] w-full",
            style: {
                borderRadius: "10px 10px 10px 10px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    className: "app-chat flex-1",
                    sx: {
                        width: "100%",
                        display: "flex",
                        borderRadius: 1,
                        position: "relative",
                        boxShadow: skin === "bordered" ? 0 : 6,
                        ...skin === "bordered" && {
                            border: "1px solid ".concat(theme.palette.divider)
                        },
                        borderRadius: "10px 10px 10px 10px"
                    },
                    children: [
                        !fetchLoading && !gatePending && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: !basicNotOver && !advancedNotOver && !justVerified ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: showUpgradeModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(extreme_upgrade/* default */.ZP, {
                                    open: true
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(side_bar, {
                            store: store,
                            hidden: hidden,
                            mdAbove: mdAbove,
                            dispatch: dispatch,
                            userStatus: userStatus,
                            getInitials: get_initials/* getInitials */.Q,
                            sidebarWidth: sidebarWidth,
                            setUserStatus: setUserStatus,
                            leftSidebarOpen: leftSidebarOpen,
                            userProfileLeftOpen: userProfileLeftOpen,
                            formatDateToMonthShort: format/* formatDateToMonthShort */.oS,
                            handleLeftSidebarToggle: handleLeftSidebarToggle,
                            handleUserProfileLeftSidebarToggle: handleUserProfileLeftSidebarToggle,
                            calls: calls,
                            setCalls: setCalls,
                            chat: chat,
                            contacts: contacts,
                            headImg: headImg,
                            setChat: setChat,
                            setHaedImg: setHaedImg,
                            setContacts: setContacts,
                            setLeftScrollTop: setLeftScrollTop,
                            leftScrollTop: leftScrollTop,
                            advanced: advanced
                        }),
                        chat && /*#__PURE__*/ (0,jsx_runtime.jsx)(content, {
                            store: store,
                            hidden: hidden,
                            mdAbove: mdAbove,
                            dispatch: dispatch,
                            getInitials: get_initials/* getInitials */.Q,
                            sidebarWidth: sidebarWidth,
                            userProfileRightOpen: userProfileRightOpen,
                            handleLeftSidebarToggle: handleLeftSidebarToggle,
                            handleUserProfileRightSidebarToggle: handleUserProfileRightSidebarToggle,
                            headImg: headImg,
                            setHaedImg: setHaedImg,
                            advanced: advanced
                        })
                    ]
                }),
                advanced && !fetchLoading && !gatePending && store.list.length == 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-center px-2 bg-white rounded-[10px] absolute z-[10] inset-0 flex justify-center items-center pointer-events-none",
                    children: [
                        t("It appears theres no data to show here yet"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        t("If data exists it may take up to 1 hour to download and appear"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        t("We suggest checking back in a little while")
                    ]
                })
            ]
        })
    });
};
WeChat.contentHeightFixed = true;
/* harmony default export */ var pages_we_chat = (WeChat);


/***/ }),

/***/ 70640:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const byteConversion = (limit)=>{
    var size = "";
    if (limit < 0.1 * 1024) {
        //小于0.1KB，则转化成B
        size = limit.toFixed(2) + " B";
    } else if (limit < 0.1 * 1024 * 1024) {
        //小于0.1MB，则转化成KB
        size = (limit / 1024).toFixed(2) + " KB";
    } else if (limit < 1024 * 1024 * 1024) {
        //小于0.1GB，则转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + " MB";
    } else {
        //其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + " GB";
    }
    var sizeStr = size + "" //转成字符串
    ;
    var index = sizeStr.indexOf(".") //获取小数点处的索引
    ;
    var dou = sizeStr.substr(index + 1, 2) //获取小数点后两位的值
    ;
    if (dou == "00") {
        //判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
    }
    return size;
};
/* harmony default export */ __webpack_exports__["Z"] = (byteConversion);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1954,518,2862,770,2607,6664,210,8863,1964,6853,7891,1558,8499,5499,5983,3769,9774,2888,179], function() { return __webpack_exec__(57407); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);